<template>
<div class="bet-detail-page">
  <div class="head_area">
    <div class="leftImg">
      <van-icon name="arrow-left" @click="$router.back()" />
    </div>
    <span class="head_text">投注详情</span>
    <span class="right_menu"></span>
  </div>
  <div class="content">
    <div class="list">
      <div class="item">
        <div class="flex-between">
         <div class="flex-between">
           <div class="game-name">{{ info.youxi_name }}</div>
           <div class="order-status" v-if="info.status">{{ info.status }}</div>
         </div>
         <div class="num-box">投注：<span>{{info.total_touzhu || '0.00' }}</span></div>
        </div>
        <div class="flex-between" style="margin-top: .23rem;">
          <div class="sequence-num">
            {{ info.sequencenum }}
          </div>
          <div class="num-box">输赢：<span>{{ info.status === '未结算' ? info.status : info.total_shuying }}</span></div>
        </div>
        <div class="game-result">开奖结果： <span v-if="info.outcome">{{ info.outcome.split('-').join(',') }}</span></div>
        <div class="table-box">
          <div class="tr table-head">
            <div class="td">类型</div>
            <div class="td">下注内容</div>
            <div class="td">金额</div>
          </div>
          <div class="table-content" v-if="info.list">
            <div class="tr" v-for="(item,index) in info.list.list" :key="index">
              <div class="td">{{ item.type }}</div>
              <div class="td">{{ item.content_t }}</div>
              <div class="td">{{ item.content_w }}</div>
            </div>
            <div class="tr merge-tr">
              <div class="td">合计总金额</div>
              <div class="td">{{ info.total_touzhu }}</div>
            </div>
            <div class="tr merge-tr">
              <div class="td">当期总输赢</div>
              <div :class="{'td': true, 'red': info.total_shuying < 0}">{{ info.status === '未结算' ? info.status : info.total_shuying }}</div>
            </div>
          </div>
        </div>
        <div class="info-box">
          <div>房间：</div>
          <div>{{ info.youxi_fangjian }}</div>
        </div>
        <div class="info-box">
          <div>开奖时间：</div>
          <div>{{ info.kjtime }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {translateText} from "../common/utils";

export default {
  name: 'betRecord',
  data() {
    return {
      id: 0,
      info: {}
    }
  },
  mounted() {
    var query = this.$route.query;
    this.id = query.id
    this.getInfo()
  },
  methods: {
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getInfo() {
      this.$apiFun.post("/api/betRecordDetail", {
        youxi_id: this.id
      }).then(async (res) => {
        if (res.code != 200) {
          this.showTost(0, res.message);
        }
        if (res.code == 200) {
          this.info = res.data
        }
      });
    },

  }
}
</script>

<style scoped lang="scss">
.bet-detail-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: .2rem .4rem;
    .list {
      .item {
        background: rgba(255, 255, 255, 0.10);
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .27rem;
        padding: .27rem;
        border-bottom: .27rem;
        .game-name {
          font-size: 0.43rem;
          color: #4858FF;
          line-height: 0.59rem;
        }
        .order-status {
          height: 0.56rem;
          line-height: .56rem;
          background: rgba(72,88,255,0.2);
          padding: 0 .19rem;
          margin-left: .19rem;
          font-size: 0.32rem;
          color: #4858FF;
        }
        .num-box {
          font-size: 0.37rem;
          color: #999999;
          span {
            font-size: 0.37rem;
            color: #4858FF;
          }
        }
        .game-result {
          font-size: 0.32rem;
          color: #999999;
          display: flex;
          align-items: center;
          margin-top: 0.11rem;
          span {
            height: 0.56rem;
            background: rgba(154,60,255,0.2);
            border-radius: 0.05rem;
            display: flex;
            align-items: center;
            padding: 0 .24rem;
          }
        }
        .table-box {
          border: .03rem solid rgba(255, 255, 255, 0.10);
          margin-top: .27rem;
          .tr {
            display: flex;
            align-items: center;
            justify-content: center;
            height: .91rem;
            border-bottom: .03rem solid rgba(255, 255, 255, 0.10);
            &:last-child {
              border: none;
            }
            .td {
              width: 33.3%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.32rem;
              border-right: .03rem solid rgba(255, 255, 255, 0.10);
              color: #4858FF;
              &:last-child {
                border: none;
              }

            }
          }
          .table-head {
            background: #515167;
            .td {
              font-size: 0.37rem;
              color: #fff;
            }
          }
          .table-content {
            .tr {
              background: #1A1A1A;
              &:nth-child(2n+2) {
                background: #2F2F2F;
              }
            }
            .merge-tr {
              .td:first-child {
                width: 66.6%;
                color: #999999;
              }
            }
          }
        }
        .info-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: .27rem;
          div {
            font-size: 0.32rem;
            color: #999999;
          }
        }
      }
    }
    .flex-between {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .red {
      color: #DB0D0D !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/betDetail.vue